var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20.25a.75.75 0 0 1-.75-.75V12a.75.75 0 0 1 .79-.75h.71a3 3 0 0 1 0 6v2.25c0 .41-.34.75-.75.75Zm.75-4.5a1.5 1.5 0 0 0 0-3v3Zm5.25 4.5a.75.75 0 0 1-.75-.75V12c0-.41.34-.75.75-.75A3.75 3.75 0 0 1 14.25 15v1.5a3.75 3.75 0 0 1-3.75 3.75Zm.75-1.63a2.26 2.26 0 0 0 1.5-2.12V15c0-.96-.62-1.8-1.5-2.12v5.74Zm5.25 1.63a.75.75 0 0 1-.75-.75v-6c0-1.24 1-2.25 2.25-2.25h1.5a.75.75 0 0 1 0 1.5H18a.75.75 0 0 0-.75.75v2.25h1.5a.75.75 0 0 1 0 1.5h-1.5v2.25c0 .41-.34.75-.75.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 22h20V6.83L17.17 2H2v20ZM2 0a2 2 0 0 0-2 2v20c0 1.1.9 2 2 2h20a2 2 0 0 0 2-2V6.83a2 2 0 0 0-.59-1.42L18.6.6A2 2 0 0 0 17.17 0H2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0a1 1 0 0 1 1 1v4.5h5a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.5bcd4848c7f76394a8407b28c4a689a3.svg";
export { ForwardRef as ReactComponent };